import React from 'react';

const STATS = [
    { count: 40, suffix: '+', label: 'VC firms', pink: true },
    { count: 60, prefix: 'Upto ', suffix: '%', label: 'AI auto-fill' },
    { count: 3, prefix: 'From ', suffix: ' days', label: 'to self-certified pack', raw: true },
];

const GLOWS = [
    { top: -100, left: -100, size: 440, c: 'rgba(252,119,133,0.38)' },
    { top: -60, right: -80, size: 480, c: 'rgba(74,103,255,0.36)' },
];

const CompaniesStatBand = () => (
    <section className="lp-stats lp-stats--glow">
        <div className="lp-stats-bg" aria-hidden="true">
            {GLOWS.map((g, i) => (
                <i key={i} style={{ top: g.top + 'px', left: g.left != null ? g.left + 'px' : 'auto', right: g.right != null ? g.right + 'px' : 'auto', width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(76px)' }} />
            ))}
        </div>
        <div className="lp-stats-grid">
            {STATS.map((s, i) => (
                <div key={i} data-lp-reveal data-lp-delay={i * 80}>
                    {s.raw
                        ? <div className={`lp-stat-num ${s.pink ? 'pink' : ''}`}>{s.prefix}{s.count}{s.suffix}</div>
                        : <div className={`lp-stat-num ${s.pink ? 'pink' : ''}`} data-count={s.count} data-prefix={s.prefix} data-suffix={s.suffix}>{s.prefix}{s.count}{s.suffix}</div>}
                    <div className="lp-stat-label">{s.label}</div>
                </div>
            ))}
        </div>
    </section>
);

export default CompaniesStatBand;
